/*global $*/
$(function () {

    'use strict';

    /* HTML detect */
    var htmlDetect = (function () {
        /* 20180327 수정 */
        var className = 'js',
            elem = document.createElement('div');

        if ('placeholder' in HTMLInputElement.prototype === false) {
            className += ' no-placeholder';
        }

        /* 20180327 추가 */
        if (elem.style.animationName === undefined) {
            className += ' no-cssanimation';
        }

        document.documentElement.setAttribute('class', className);
    }()),

        /* PC화면 detect */
        isDesktop = function () {
            return window.innerWidth >= 1024;
        },

        /* 맨위로 가기 버튼 이벤트 */
        setBtnTop = (function () {
            if (!document.querySelector('.btn_top')) {
                return false;
            }

            /* 20180316 수정 */
            var timer = null,
                $btnTop = $('.btn_top'),
                originWidth = $(window).width(),
                originHeight = $(window).height();

            $btnTop.on('click', function (e) {
                e.preventDefault();
                $('html, body').stop().animate({scrollTop: 0}, 250);
            });

            $(window).on('scroll', function () {
                /* 20180316 수정 */
                if (timer) {
                    clearTimeout(timer);
                }

                timer = setTimeout(function () {
                    var ypos = $(window).scrollTop(),
                        hdHeight = $('.header').outerHeight() === 0 ? $('.sub_hd').outerHeight() : $('.header').outerHeight();

                    if(ypos > hdHeight) {
                        $btnTop.attr('data-status','show');
                        /*  20180316 수정*/
                        $('body').attr('data-status', 'onscroll');
                    } else {
                        $btnTop.attr('data-status','hide');
                        /*  20180316 수정*/
                        $('body').attr('data-status', '');
                    }
                }, 4);
            })
            .on('resize', function () {
                if ($(window).width() !== originWidth || $(window).height() !== originHeight) {
                    $('html, body').stop().animate({scrollTop : $(window).scrollTop() - 1});
                }
            });
        }()),

        /* 모바일 서브 헤더가 있을때 메인헤더 숨김 */
        setSubHd = (function () {
            if (!document.querySelector('.sub_hd')) {
                return false;
            }

            var init = function () {
                var $header = $('.header');

                !isDesktop() ? $header.addClass('hidden') : $header.removeClass('hidden');
            };

            init();

            $(window).on('resize', init);
        }()),

        /* 커스텀 placeholder */
        setInputPlaceholder = (function () {
            if (!document.querySelector('[data-placehold]')) {
                return false;
            }

            $('[data-placehold]').html('<span class="default_placeholder">선택해주세요</span>');
        }()),

        /* 커스텀 selectbox 이벤트 */
        setCustomSelectBox = (function () {
            if(!document.querySelector('.select_wrap')) {
                return false;
            }

            var chgSelectTxt = function (el) {
                var $el = $(el),
                    selectedTxt = $el.find('option').filter(':selected').text();

                //회원가입 전화 국가번호일때 숫자값만 가져옴
                if ($el.closest('.phone_prefix').length) {
                    selectedTxt = '+' + $el.val();
                }

                $el.prev().find('.selected_txt').text(selectedTxt);
            };

            /* 20180511 수정 */
            $(document).on('click', '.select_wrap', function () {
                var $this = $(this);

                if(!$this.hasClass('expanded')) {
                    $('.select_wrap').filter('.expanded').removeClass('expanded');
                }

                $this.toggleClass('expanded');
            })
            .on('change', 'select', function (e) {
                chgSelectTxt(this);
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.select_wrap').length) {
                    $('.select_wrap').filter('.expanded').removeClass('expanded');
                }
            });

            $('.select_wrap select').each(function () {
                chgSelectTxt(this);
            });

            //회원가입 이메일 입력 셀렉트 박스 이벤트
            $('.email_vendor select').on('change', function () {
                var $this = $(this),
                    selectedTxt = $(this).find('option').filter(':selected').text();
                if (selectedTxt !== '직접입력') {
                    $('.i_email_vendor').val($(this).val());
                } else {
                    $('.i_email_vendor').val('').focus();
                }
            });

            /* 20180511 수정 */
            //소속단체 입력 셀렉트 박스 이벤트
            $(document).on('change', '.assoc_vendor', function () {
                var $this = $(this),
                    selectedTxt = $(this).find('option').filter(':selected').text(),
                    $input = $('.i_assoc_vendor');
                if (selectedTxt !== '직접입력') {
                    $input.parent().addClass('hidden').val('');
                } else {
                    $input.parent().removeClass('hidden').val('');
                    $input.focus();
                }
            });
        }()),

        /* placeholder IE9 지원 */
        detectPlaceholder = (function () {
            if (!document.querySelector('input[placeholder]')) {
                return false;
            }

            var detect = 'placeholder' in document.createElement('input'),
                $inputs = $('[placeholder]'),
                init = function (el) {
                    var $el = $(el),
                        txt = $el.attr('placeholder');
                    
                    if (!$el.attr('data-type')) {
                        $el.attr('data-type', $el.attr('type'));
                    }

                    if (!$el.val()) {
                        $el.val(txt).addClass('pholder');
                    }

                    chkPasswordInput(el);
                },
                chkPasswordInput = function (el) {
                    var $el = $(el),
                        txt = $el.attr('placeholder');

                    if ($el.attr('data-type') === 'password') {
                        $el.val() === txt ? $el.attr('type','text') : $el.attr('type','password');
                    }
                };

            if(!detect) {
                $inputs.each(function () {
                    init(this);
                });

                $inputs.on('focusin', function () {
                    var $this = $(this);

                    if ($this.val() === $this.attr('placeholder')) {
                        $this.val('').focus();
                        $this.removeClass('pholder');
                    }

                    chkPasswordInput(this);
                })
                .on('focusout', function () {
                    init(this);
                });
            }
        }()),

        /* 드롭다운박스 이벤트 */
        setDropbox = (function () {
            if (!document.querySelector('.ddbox_wrap')) {
                return false;
            }

            var wrapClass = '.ddbox_wrap';

            /* 20180511 수정 */
            $(document).on('click', '.btn_show_list', function (e) {
                e.preventDefault();
                var $wrap = $(this).closest(wrapClass),
                    $dropbox = $(wrapClass).filter('.show'),
                    ypos = 0;/* 20180316 추가 */

                if (!$wrap.find('.ddbox').length) {
                    return false;
                }

                if ($dropbox.length && !$wrap.hasClass('show')) {
                    $dropbox.removeClass('show');
                }

                /* 20180316 추가 */
                /* 메인페이지 상단 검색 스크롤링 */
                if (!$wrap.hasClass('show') && $(this).closest('.main_srch_frm').length) {
                    ypos = $(this).closest('.ddbox_wrap').offset().top - $('.header').outerHeight();

                    $(window).scrollTop() < ypos ? $('html, body').stop().animate({scrollTop : ypos}, 200) : false;
                }

                $wrap.toggleClass('show');
            });

            $(document).on('click', function (e) {
                var $dropbox = $(wrapClass).filter('.show');
                if ($dropbox.length && !$(e.target).closest(wrapClass).length) {
                    $dropbox.removeClass('show');
                }
            });
        }()),

        /* 메인 검색 listbox 이벤트 */
        setListbox = (function () {
            if(!document.querySelector('.listbox')) {
                return false;
            }

            var $listbox = $('.listbox'),
                chgSelectedLabel = function (el) {
                    var $el = $(el),
                        $parent = $el.parent(),
                        wrapClass = '.ddbox_wrap';

                    $parent.addClass('active').siblings().removeClass('active');
                    $el.closest(wrapClass).removeClass('show').find('.selected_txt').text($el.text());
                };

            $listbox.on('click', '.item', function (e) {
                chgSelectedLabel(this);

                if(this.getAttribute('href')) {
                   return false;
                }
            });

            $listbox.on('keydown', 'input' , function (e) {
                if (e.keyCode === 13) {
                    e.preventDefault();
                    chgSelectedLabel($(this).next()[0]);
                }
            });

            $listbox.each(function () {
                /* 20180511 추가 */
                var $this = $(this);

                /* 20180511 수정 */
                if (!$this.find('.active').length || $this.find('.active input')[0].checked === false) {
                    $this.find('.item').eq(0).trigger('click');
                }
            });
        }()),

        /* main 검색 check in, check out, people 팝업 이벤트 */
        setMainSearchOptPopup = (function () {
            if (!document.querySelector('.main_srch_frm')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.i_check_date', function (e) {
                $('.check_datepicker').addClass('show');
            })
                .on('keydown', function (e) {
                    /*  20180511 추가 */
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        $(this).trigger('click');
                    }
                });

            /* 20180511 수정 */
            $(document).on('click', '.btn_view_people_counter', function () {
                $('.people_counter_wrap').toggleClass('show');
            });

            $(document).on('click', function (e) {
                if ($('.check_datepicker').hasClass('show') && !$(e.target).closest('.i_check_date').length
                    && !$(e.target).closest('.check_datepicker').length) {
                    $('.check_datepicker').removeClass('show');
                }

                if ($('.people_counter_wrap').hasClass('show') && !$(e.target).closest('.btn_view_people_counter').length
                    && !$(e.target).closest('.people_counter_wrap').length) {
                    $('.people_counter_wrap').removeClass('show');
                }
            });
        }()),

        /* 달력 생성 및 클릭 이벤트 */
        setChgDatepickerLabel = (function () {
            if(!document.querySelector('.check_datepicker')) {
                return false;
            }

            var getDateObj = function (strDate) {
                /* 날짜 형식 변경 (yyyy-mm-dd) => (yyyy/mm/dd) */
                /* 20180320 수정 */
                strDate = !strDate.match(/-/g) ? strDate : strDate.replace(/-/g, '/');
                /* Date 객체 반환 */
                return new Date(new Date(strDate).setHours(0,0,0,0));
            },
                getNumberOfMonths = function (container) {
                    return $(window).width() < 700 ? 1 : $(container.parentNode).hasClass('single') ? 1 :2;
                },
                chgDateInput = function ($el, strDate) {
                    /* 날짜 라벨 변경 */
                    if ($el.parent().find('.day').length) {
                        $el.val(strDate).parent().find('.day').text(strDate.split('-')[2]).siblings('.year').text(strDate.split('-')[0] + '.' + strDate.split('-')[1]);
                    } else {
                        $el.val(strDate).parent().find('.selected_txt').text(strDate.split('-')[0] + '.' + strDate.split('-')[1] + '.' + strDate.split('-')[2]);
                    }
                },
                create = function (input1, input2, container) {
                    /* 달력 생성 */
                    var $chkIn = $(input1), $chkOut = $(input2),
                        $container = $(container),
                        dragging = false, //드래그 플래그
                        startDate = $chkIn.val().replace('-','/'), /* 20180316 수정 */
                        endDate = $chkOut.val().replace('-','/'); /* 20180316 수정 */

                    /* 메인검색 페이지일때 최근 날짜 선택 */
                    if($('.main_srch_frm').length) {
                        /* 20180316 수정 */
                        startDate = startDate ? new Date(startDate) : new Date();
                        endDate = endDate ? new Date(endDate) : new Date(startDate.getTime() + (4*1000*60*60*24));
                    }
                    
                    /* 시작날짜와 종료날짜가 있을때 라벨변경 */
                    if (startDate && endDate) {
                        startDate = new Date(startDate.setHours(0,0,0,0));
                        endDate = new Date(endDate.setHours(0,0,0,0));

                        chgDateInput($chkIn, $.datepicker.formatDate('yy-mm-dd', startDate));
                        chgDateInput($chkOut, $.datepicker.formatDate('yy-mm-dd', endDate));
                    }

                    $container.datepicker({
                      dateFormat: 'yy-mm-dd',
                      minDate: 0,
                      defaultDate: 0,
                      numberOfMonths: getNumberOfMonths($container[0]),
                      prevText: '이전 달',
                      nextText: '다음 달',
                      monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                      monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                      dayNames: ['일', '월', '화', '수', '목', '금', '토'],
                      dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
                      dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
                      showMonthAfterYear: true,
                      yearSuffix: '년',
                      beforeShowDay: function (date) {
                        /* datepicker 클래스 변경 */
                        var days = [],
                            curTime = date.getTime();

                        if (dragging && curTime < startDate.getTime()) {
                            days = [false, ''];
                        } else {
                            days = [true, ''];
                        }

                        if (startDate && endDate && curTime > startDate.getTime() && curTime < endDate.getTime()) {
                            days = [true, 'active_day include_day'];
                        }

                        if (startDate && curTime === startDate.getTime()) {
                            days = [true, 'active_day in_day'];
                        }

                        if (endDate && curTime === endDate.getTime()) {
                            days = [true, 'active_day out_day'];
                        }

                        return days;
                      },
                      onSelect: function (date) {
                        //1. 시작날짜선택
                        //2. 라벨 업데이트
                        //3. 드래그 하여 영역설정
                        //4. 마지막날 선택
                        //5. 라벨 업데이트
                        if(!dragging) {

                            dragging = true;
                            $container.removeClass('done');

                            chgDateInput($chkIn, date);

                            endDate = null;
                            startDate = getDateObj(date);

                            $container.on('mouseenter focusin', 'td', function (e) {
                                if(!dragging) {
                                    return false;
                                }

                                var start = startDate.getTime(),
                                    year = $(this).attr('data-year'), month = (Number($(this).attr('data-month')) + 1), day = Number($(this).children(0).text()),
                                    end = getDateObj(year + '-' + (month < 10 ? '0'+month : month) + '-' + (day < 10 ? '0'+day : day)).getTime(),
                                    gap = Math.ceil((end - start) / 1000 / 60 / 60 / 24),
                                    prev = null,
                                    curidx = 0,
                                    tempEl = null,
                                    tempDate = null,
                                    $cells = $container.find('.ui-datepicker-calendar td').filter(function () {
                                        return $(this).hasClass('ui-state-disabled') ? false : true;
                                    });

                                $container.find('.include_day').removeClass('active_day').removeClass('include_day');

                                if(gap > 0) {
                                    curidx = $cells.index(this);

                                    for(var i=0; i<=curidx; i++) {
                                        tempEl = $cells.eq(curidx-i);
                                        year = tempEl.attr('data-year'), month = Number(tempEl.attr('data-month')) + 1, day = Number(tempEl.children(0).text());
                                        tempDate = getDateObj(year + '-' + (month < 10 ? '0'+month : month) + '-'+ (day < 10 ? '0'+day : day)).getTime();

                                        if (tempDate > start && tempDate <= end) {
                                            $cells.eq(curidx - i).addClass('active_day include_day');
                                        }
                                    }

                                }
                            });
                        } else {
                            dragging = false;
                            $container.addClass('done');
                            chgDateInput($chkOut, date);
                            endDate = getDateObj(date);

                            $(document).trigger('click');
                        }
                      }
                    });
                };

            $('.check_datepicker').each(function () {
                var $this = $(this),
                    input1 = $this.parent().find('.i_check_date')[0],
                    input2 = $this.parent().find('.i_check_date')[1],
                    container = $(this).find('.datepicker_container')[0];

                create(input1, input2, container);

                $(window).on('resize', function () {
                    var num = getNumberOfMonths(container);
                    $(container).datepicker('option', 'numberOfMonths', num);
                });
            });

            /* 20180511 삭제
            $('.i_check_date').on('focus', function () {
                $(this).blur();
            });*/

            $(document).on('click', '.ui-datepicker-header',function (e) {
                e.preventDefault();
                return false;
            });
        }()),

        /* 카운터 증가, 감소 버튼 이벤트 */
        setBtnCounter = (function () {
            if (!document.querySelector('.btn_cnt_up') || !document.querySelector('.btn_cnt_down')) {
                return false;
            }

            var chgCounter = function (el, type) {
                var $counter = $(el).parent().find('.i_cnt'),
                    $down = $(el).parent().find('.btn_cnt_down'),
                    num = Number($counter.val())

                if (type === 'up') {
                    num +=1;
                } else if (num !== 0) {
                    num -=1;
                }

                $counter.val(num);

                if(num === 0) {
                    $down.attr('disabled', 'disabled');
                } else {
                    $down.removeAttr('disabled');
                }
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_cnt_up', function () {
                chgCounter(this, 'up');
            });

            /* 20180511 수정 */
            $(document).on('click', '.btn_cnt_down', function () {
                chgCounter(this, 'down');
            });

            /* 20180511 수정 */
            $(document).on('focusin', '.counter .i_cnt', function() {
                $(this).blur();
            });
        }()),

        /* 메인 검색 people 라벨과 카운터 동기화 */
        chgMainSearchPeopleNumber = (function () {
            if (!document.querySelector('.main_srch_frm') || !document.querySelector('.label_people')) {
                return false;
            }

            var $wrap = $('.people_counter_wrap'),
                $selectedVal = $('.label_people').next().find('.selected_val'),
                chgSelectedValue = function () {
                    var sum = 0;

                    $wrap.find('.i_cnt').each(function () {
                        sum += Number($(this).val());
                    });

                    $selectedVal.text(sum);
                };

            $wrap.on('keyup', '.i_cnt', function () {
                chgSelectedValue();
                if (this.value === null) {
                    this.value = 0;
                }
            });

            /* 20180511 수정 */
            $(document).on('click', '.btn_cnt_up', chgSelectedValue);
            $(document).on('click', '.btn_cnt_down', chgSelectedValue);

            chgSelectedValue();
        }()),

        /* 전체 캐로셀 생성 */
        setCarousel = (function () {
            if ($.fn.owlCarousel === undefined) {
                return false;
            }
            var opts = {
                main: {
                    items: 1,
                    loop: true,
                    autoplay: true,
                    autoplayTimeout: 6000,
                    dotsContainer: '.main_carousel_dot',
                    dotData: true,
                    smartSpeed: 700,
                    responsiveRefreshRate: 100,
                    onInitialize: function (event) {
                        $('.visual_circle').on('mousedown', function (e) {
                            e.stopPropagation();
                        });

                    },
                    onTranslate: function (event) {
                        var $wrapper = $('.main_carousel_wrap'),
                            $btn = $('.main_carousel_controller .btn_play_control');

                        if($btn.hasClass('pause')) {
                            $btn.trigger('click');
                        }

                        if ($(event.target).find('.visual').eq(event.page.index).hasClass('dark')) {
                           $wrapper.addClass('brightly');
                        } else {
                           $wrapper.removeClass('brightly');
                        }
                    },
                    onResize: function (event) {
                        var $btn = $('.main_carousel_controller .btn_play_control');

                        if($btn.hasClass('pause')) {
                            $btn.trigger('click');
                        }
                    }
                },
                mainEarlybird: {
                    autoWidth: true,
                    center: true,
                    loop: true,
                    dots: false,
                    smartSpeed: 400,
                    responsiveRefreshRate: 100,
                    responsive:{
                        1024: {
                            items: 4,
                            autoWidth: false,
                            center: false,
                            loop: false
                        }
                    },
                    onInitialized: function (evt) {
                        var $target = $(evt.target);

                        $target.on('mouseover focusin', '.item' ,function () {
                            $(this).parent().siblings().removeClass('focused');
                            $(this).parent().addClass('focused');
                        });

                        if (isDesktop()) {
                            $target.find('.owl-item').eq(1).addClass('focused');
                        } else {
                            $target.find('.center').addClass('focused');
                        }
                    }
                },
                mainEvent: {
                    items: 1,
                    loop: true,
                    nav: true,
                    navElement: 'button',
                    navText: ['이전','다음'],
                    dots: false,
                    lazyLoad:true,
                    smartSpeed: 400,
                    responsiveRefreshRate: 100,
                    responsive:{
                        1024: {
                            items: 3,
                            margin: 34
                        }
                    }
                },
                thumb: {
                    items: 1,
                    loop: true,
                    nav: false,
                    dots: true,
                    lazyLoad: true,
                    smartSpeed: 400,
                    responsiveRefreshRate: 100,
                    onInitialized: function (evt) {
                        /* 커스텀 컨트롤러 생성 */
                        var $target = $(evt.target),
                            len = $target.find('.owl-item:not(.cloned)').length,
                            html = '';

                        $target.find('.owl-item').height($target.outerHeight());

                        if (len > 1) {
                            html += '<div class="thumb_controller" style="height:'+ $target.outerHeight() +'px;">'
                                + '<div class="thumb_dots">';
                            for(var i=0; i<len; i++) {
                                html += '<a href="#" class="dot '+ (i === 0 ? 'active' : '') +'">' + (i+1) + '</a>';
                            }
                            html += '</div><div class="thumb_nav">'
                                + '<button type="button" class="btn_prev">이전</button>'
                                + '<button type="button" class="btn_next">다음</button>'
                                +'</div></div>';
                            $target.parent().after(html);
                        }

                        $target.parent().siblings('.thumb_controller').on('click', '.btn_next', function (e) {
                            e.preventDefault();
                            $target.trigger('next.owl.carousel');
                        });

                        $target.parent().siblings('.thumb_controller').on('click', '.btn_prev', function (e) {
                            e.preventDefault();
                            $target.trigger('prev.owl.carousel');
                        });

                        $target.parent().siblings('.thumb_controller').on('click', '.dot', function (e) {
                            e.preventDefault();
                            $target.trigger('to.owl.carousel', [$(this).index()]);
                        });

                        $target.on('changed.owl.carousel', function (e) {
                            var idx = $(e.target).find('.owl-dot').filter('.active').index(),
                                $dots = $(e.target).parent().siblings('.thumb_controller').find('.dot');
                            $dots.filter('.active').removeClass('active');
                            $dots.eq(idx).addClass('active');
                        });

                        /* 썸네일 height 새로고침 */
                        $(window).on('resize', function () {
                            $target.find('.owl-item').height($target.outerHeight());
                            $('.thumb_controller').height($target.outerHeight());
                        });
                    }
                },
                place: {
                    items: 1,
                    loop: true,
                    nav: true,
                    navElement: 'button',
                    navText: ['이전','다음'],
                    dots: true,
                    lazyLoad: true,
                    smartSpeed: 400,
                    onInitialize: function (evt) {
                        /* 슬라이더 썸네일 리스트와 팝업 슬라이더 생성 */
                        var $target = $(evt.target),
                            imgs = $target.find('img'),
                            html = '';

                        var select = function (el) {
                            var $el = $(el),
                                center = ($el.position().left + ($el.outerWidth()/2)),
                                width = $el.closest('.place_carousel_dots').outerWidth(),
                                min = width - $el.closest('.dots_container').outerWidth(),
                                max = 0, xpos = (width/2) - center;

                            $el.siblings().removeClass('on');
                            $el.addClass('on');

                            if (xpos > max) {
                                xpos = max;
                            } else if (xpos < min) {
                                xpos = min;
                            }

                            $el.parent().css({
                                transform: 'translate(' + xpos + 'px,0px)'
                            });
                        };

                        html += '<div class="place_carousel_dots"><div class="dots_container">';
                        for(var i=0, len=imgs.length; i<len; i++) {
                            html += '<div class="thumb_dot' + (i === 0 ? ' on':'') + '">'
                                +'<button type="button" class="btn_thumb">'
                                + '<img src="' + imgs.eq(i).attr('data-src') + '" alt="" />'
                                + '</button></div>';
                        }
                        html +='</div></div>';

                        $target.after(html);

                        $('.place_carousel_dots .dots_container').css({
                            width: $('.thumb_dot').outerWidth() * imgs.length
                        });

                        $('.zoom_photo .popup_content').html('').append($target.clone());

                        window.zoomCarousel = $('.zoom_photo .place_carousel');
                        initCarousel(zoomCarousel,opts.zoom);
                        zoomCarousel.on('refresh.owl.carousel');

                        $target.on('changed.owl.carousel', function (e){
                            var idx = $(e.target).find('.owl-dot.active').index();
                            idx = idx < 0 ? 0:idx;
                            select($('.place_carousel_dots .thumb_dot')[idx]);
                        });

                        $('.place_carousel_dots').on('click', '.thumb_dot', function (e) {
                            var $this = $(this);
                            select(this);
                            $target.trigger('to.owl.carousel', $this.index());
                        });

                        $(window).on('resize', function () {
                            var idx = $target.find('.owl-dot.active').index();
                            select($('.thumb_dot').eq(idx));
                        });
                    }
                },
                zoom: {
                    items: 1,
                    loop: true,
                    nav: true,
                    navElement: 'button',
                    navText: ['이전', '다음'],
                    dots: false,
                    mouseDrag: false,
                    lazyLoad: true,
                    responsiveRefreshRate: 1
                }
            },
                initCarousel = function ($el, opt) {
                    if ($el.length) {
                        $el.addClass('owl-carousel'); /* 캐로셀 생성을 위한 owl-carousel 클래스 추가 */
                        !opt ? $el.owlCarousel() : $el.owlCarousel(opt);
                    }
                };

            if (document.querySelector('.main_carousel')) {
                //메인 비주얼
                window.mainCarousel = $('.main_carousel');
                window.visualInnerCarousel = $('.visual_inner_carousel');
                initCarousel(mainCarousel, opts.main);
            }
            if (document.querySelector('.main_earlybird_carousel')) {
                //메인 얼리버트 할인
                window.mainEarlybird = $('.main_earlybird_carousel');
                initCarousel(mainEarlybird, opts.mainEarlybird);

                mainEarlybird.on('resized.owl.carousel', function () {
                    if(isDesktop()) {
                        $(this).find('.center').removeClass('center');
                    }
                });
            }
            if (document.querySelector('.main_event_carousel')) {
                //메인 다이빙리조트 이벤트
                window.mainEvent = $('.main_event_carousel');
                initCarousel(mainEvent, opts.mainEvent);

                mainEvent.find('.owl-nav').removeClass('disabled');

                mainEvent.on('resized.owl.carousel refreshed.owl.carousel', function () {
                    $(this).find('.owl-nav').removeClass('disabled');
                });
            }
            if (document.querySelector('.thumb_carousel')) {
                window.thumbCarousel = $('.thumb_carousel');
                initCarousel(thumbCarousel, opts.thumb);
            }
            if (document.querySelector('.place_carousel')) {
                window.placeCarousel = $('.place_carousel');
                initCarousel(placeCarousel, opts.place);
            }
        }()),
        /* 메인 비주얼 autoplay 제어 버튼 이벤트 */
        setBtnPause = (function () {
            if (!document.querySelector('.btn_play_control')) {
                return false;
            }

            $('.main_carousel_controller .btn_play_control').on('click', function () {
                if (!$(this).hasClass('pause')) {
                    $(this).toggleClass('pause').find('.icon_pause').attr('class', 'icon_play').text('재생');
                    window.mainCarousel.trigger('stop.owl.autoplay');
                } else {
                    $(this).toggleClass('pause').find('.icon_play').attr('class', 'icon_pause').text('멈춤');
                    window.mainCarousel.trigger('play.owl.autoplay');
                }
            });
        }()),
        /* desktop gnb 마이메뉴 표시, 숨기기 이벤트 */
        showMyMenu = (function() {
            var hideTimeout = null,
                $myMenu = $('.gnb_my_menu');

            $('.btn_show_my_menu').on('focusin mouseenter', function () {
                $(this).parent().addClass('on');
                $myMenu.show();
            });

            $('.gnb_my_menu, .btn_show_my_menu').on('focusout mouseleave', function () {
                hideTimeout = setTimeout(function () {
                    $myMenu.parent().removeClass('on');
                    $myMenu.hide();
                }, 100);
            })
            .on('focusin mouseenter', function () {
                clearTimeout(hideTimeout);
            });
        }()),

        /* gnb 검색 열기 */
        showGnbSearch = (function () {
            if(!document.querySelector('.header_search')) {
                return false;
            }
            /* 20180316 수정 */
            var $searchWrap = $('.header_search'),
                $header = $('.header');

            $('.header .btn_search').on('click', function (e) {
                /* 20180316 수정 */
                e.preventDefault();

                $searchWrap.hasClass('expanded') ? $header.attr('data-expand', '') : $header.attr('data-expand', 'true');

                $searchWrap.toggleClass('expanded').stop().slideToggle(200, function () {
                    $searchWrap.hasClass('expanded') ? $searchWrap.find('.i_search').focus() : $searchWrap.find('.i_search').val('');
                });
            });
        }()),

        /* 검색어 입력 지우기 버튼 표시, 숨김 */
        showInputClear = (function () {
            if(!document.querySelector('.clear_input')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('keydown keyup', '.i_search', function () {
                if(this.value.length > 0) {
                    $(this).siblings('.clear_input').show();
                } else {
                    $(this).siblings('.clear_input').hide();
                }
            });

            /* 20180511 수정 */
            $(document).on('click', '.clear_input', function () {
                $(this).hide();
                $(this).siblings('.i_search').val('').focus();
            });
        }()),

        /* 아코디언 리스트 열기,닫기 */
        setAccordionList = (function () {
            if(!document.querySelector('.accordion_list')) {
                return false;
            }

            $('.accordion_list').on('click', 'li', function (e) {
                e.preventDefault();
                var $this = $(this);

                if ($(e.target).closest('.acc_wrap').length) {
                    return false;
                }

                $this.siblings().removeClass('expanded').find('.acc_wrap').stop().slideUp(200);
                $this.toggleClass('expanded').find('.acc_wrap').stop().slideToggle(200);
            });
        }()),
        /* 좋아요 버튼 이벤트 */
        setLikeBtn = (function () {
            if (!document.querySelector('.btn_like')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_like', function () {
                var text = '좋아요 취소';

                if (!$(this).hasClass('on')) {
                    $(this).addClass('on ani').text('좋아요 취소');
                } else {
                    $(this).removeClass('on').text('좋아요 선택');
                }
            }).
            on('animationend webkitAnimationEnd oAnimationEnd', '.btn_like', function () {
                $(this).removeClass('ani');
            });
        }()),
        /* 원페이지 스크롤 탭메뉴 이벤트 */
        setPageScrollTabMenu = (function () {
            if (!document.querySelector('.tab_menu[data-sticky]')) {
                return false;
            }
            var height = 0,
                listYpos = 0,
                $header = $('.header'),/* 20180316 추가 */
                $container = $('.tab_menu[data-sticky]'),
                $list = $container.children('.tab_list'),
                $panel = $container.children('.tab_panel'),
                offset = 100,
                timer = null,
                init = function () {
                    height = $list.height(),
                    listYpos = $list.offset().top;

                    $list.css({
                        width: $container.outerWidth(),
                        height: $list.outerHeight()
                    });

                    $list.on('click', 'li' ,function (e) {
                        e.preventDefault();

                        var $this = $(this),
                            idx = $list.children().index(this),
                            curpos = $(window).scrollTop(),
                            ypos = ($panel.eq(idx).position().top - height) + $container.offset().top,
                            id = $this.children().attr('href') || '';

                        if(ypos !== $(window).scrollTop()) {
                            $(id).focus();
                            $(window).scrollTop(curpos);
                            $('html, body').stop().animate({'scrollTop':ypos}, 400);
                        }
                    });

                    $list.find('li').eq(0).addClass('on');

                    $(window).on('scroll', function () {
                       if (timer) {
                            clearTimeout(timer);
                       }

                       timer = setTimeout(function () {
                          var curPos = $(window).scrollTop();

                          if (curPos > listYpos) {
                              $list.attr('data-status','sticky');
                              /* 20180316 추가 */
                              $header.attr('data-status','top');
                          } else {
                              $list.attr('data-status','');
                              /* 20180316 추가 */
                              $header.attr('data-status','');
                          }

                          $panel.each(function (idx) {
                              var $this = $(this),
                                  ypos = ($this.position().top - offset) + $container.offset().top,
                                  endYpos = ypos + ($this.outerHeight() - offset);

                              if (curPos >= ypos && curPos < endYpos) {
                                  $list.children().siblings().filter('.on').removeClass('on');
                                  $list.children().eq(idx).addClass('on');
                              }
                          });
                        }, 4);
                    })
                    .on('resize', function () {
                        listYpos = $container.offset().top;
                        $list.attr('style','').css({
                            width: $container.outerWidth(),
                            height: $list.outerHeight()
                        });

                        height = $list.outerHeight();
                    });

                };

            $(window).on('load', init);
        }()),
        /* 검색바 모두보기 버튼 이벤트 */
        setBtnShowAll = (function () {
            if(!document.querySelector('.btn_show_all')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_show_all', function () {
                var $this = $(this),
                    curTxt = $this.text(),
                    txt = curTxt.indexOf('접기') > -1 ? curTxt.replace('접기','모두 보기') : curTxt.replace('모두 보기','접기');

                $this.parent().toggleClass('collapsed').toggleClass('expanded');
                $this.text(txt);
            });
        }()),
        /* 검색바 날짜선택 이벤트 */
        setDateInput = (function () {
            if (!document.querySelector('.attr_list')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click focusin', '.date_input', function () {
                $(this).parent().addClass('expanded');
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.date_input').length && !$(e.target).closest('.check_datepicker').length) {
                    $('.date_input').parent().filter('.expanded').removeClass('expanded');
                }
            });
        }()),
        /* 가격 범위 지정 슬라이더 */
        setPriceAmount = (function () {
            if (!document.querySelector('.price_amount')) {
                return false;
            }

            var min = parseInt($('.price_range .min_price').text()) || 10000,/* 20180612 수정 */
                max = parseInt($('.price_range .max_price').text()) || 1000000,/* 20180612 수정 */
                values = [min, max],
                html = '';

            $('.price_amount').slider({
                range: true,
                min: min,
                max: max,
                values: values,
                step: 10000,
                slide: function (event, ui) {
                    $('.min_price').text(ui.values[0]);
                    $('.max_price').text(ui.values[1]);
                },
                create: function (event, ui) {
                    $('.min_price').text(min);
                    $('.max_price').text(max);

                    /* 가격 그래프 그리기 (임시 random 값) */
                    for(var i=0, len=25; i<len; i++) {
                        html +='<div class="graph_bar" style="height: '+ parseInt(Math.random()*50) +'px;"></div>';
                    }
                    $('.price_graph .graph_wrap').html(html);
                }
            });

            /* /터치 이벤트 */
            $(document).on('touchstart', '.ui-slider-handle', function (e) {
                var $handle = $(this),
                    $slider = $(this.parentNode);

                $(document).on('touchmove', function (e) {
                    var evt = e.originalEvent,
                        idx = $slider.find('.ui-slider-handle').index($handle),
                        left = evt.touches[0].clientX - $slider.offset().left,
                        xpos = ((left / $slider.width())).toFixed(4),
                        max = $slider.slider('option','max'),
                        value = 0, target = '';

                    if (idx === 1) {
                        target = '.max_price';
                    } else {
                        target = '.min_price';
                    }

                    value = parseInt(max * xpos);
                    $slider.slider('values', idx, value);
                    $(target).text($slider.slider('values')[idx]);
                });

                $(document).on('touchend', function () {
                    $(document).off('touchmove');
                });
            });
        }()),
        /* 뷰페이지 좌측 검색바 및 탭메뉴 고정 */
        setViewPageFixedContent = (function () {
            if (!document.querySelector('.view_page')) {
                return false;
            }

            var fixedSearchBar = function () {
                if ($('.search_bar')) {
                    return false;
                }

                var timer = null,
                    /*  20180316 수정*/
                    $header = $('.header'), $bar = $('.search_bar'), $container = $('#sctCancel'),
                    minpos = $bar.parent().offset().top,
                    maxpos = $container.offset().top + $container.height() - $bar.height();

                $(window).on('scroll', function () {
                  if (timer) {
                      clearTimeout(timer);
                  }
                  timer = setTimeout(function () {
                      var curYpos = $(window).scrollTop();

                      if(curYpos > minpos && curYpos < maxpos) {
                          $bar.attr('style','').attr('data-status','sticky');
                      } else if (curYpos >= maxpos) {
                          $bar.attr('data-status','ended').css('top', maxpos);
                      } else {
                          $bar.attr('style','').attr('data-status','');
                      }
                  }, 1);
                })
                .on('resize', function () {
                    minpos = $bar.parent().offset().top,
                    maxpos = $container.offset().top + $container.height() - $bar.height();
                });
            },
                setMobileScroll = function () {
                    var timer = null,
                        minpos = $('.sub_hd').outerHeight(),
                        maxpos = $('.footer').offset().top;

                    $(window).on('scroll', function () {
                        if (!isDesktop()) {
                          if (timer) {
                            clearTimeout(timer);
                          }

                          timer = setTimeout(function () {
                            var curpos = $(window).scrollTop();

                            if (curpos > minpos && curpos < maxpos ) {
                                $('body').attr('data-scroll-view', 'scrolled');
                            } else {
                                $('body').attr('data-scroll-view', '');
                            }
                          }, 3);
                        }
                    })
                    .on('resize', function () {
                        if (isDesktop()) {
                            $('body').removeAttr('data-scroll-view');
                        } else {
                            minpos = $('.sub_hd').outerHeight();
                            maxpos = $('.footer').offset().top;
                        }
                    });
                };

            $(window).on('load', function () {
                fixedSearchBar();
                setMobileScroll();

                /* 20180615 추가 */
                if (!isDesktop() && $('.page_sub_inner').length && !$('.place_carousel_wrap').length) {
                    $('.page_sub_inner').css('marginTop', '0');
                }
            });

            /* 20180615 추가 */
            $(window).on('resize', function () {
                if (!isDesktop() && $('.page_sub_inner').length && !$('.place_carousel_wrap').length) {
                    $('.page_sub_inner').css('marginTop', '0');
                } else {
                    $('.page_sub_inner').css('marginTop', '');
                }
            });
        }()),
        /* 모달팝업 */
        setModalPopup = (function () {
            var setPopup = function (elName, targetName) {
                $(document).on('click', elName, function (e) {
                    e.preventDefault();

                    if (!$(targetName).length) {
                        return false;
                    }

                    $(targetName).addClass('show').scrollTop(0).find('.popup_container').attr('data-visible','show');
                    $('body').addClass('noscroll');
                });
            },
                close = function (target) {
                    /* 20180511 수정 */
                    var $popup = $(target).closest('.popup');
                    
                    if ($popup.length) {
                        $popup.removeClass('show').find('.popup_container').removeAttr('data-visible');
                    } else {
                        $('.popup').filter('.show').removeClass('show').find('.popup_container').removeAttr('data-visible');
                    }

                    if ($popup.find('form').length) {
                        $popup.find('form').each(function () {
                            this.reset();
                        });
                    }

                    $('body').removeClass('noscroll');
                };

            $(document).on('click', '.btn_close_popup',function () {
                close(this);
                return false;
            });

            $(document).on('click', function (e) {
                if ($(e.target).hasClass('popup') && !$(e.target).closest('.popup_container').length) {
                    close(e.target);
                }
            });

            $(document).on('click', '.popup .btn_cancel', function () {
                close(this);
                return false;
            });
            $(document).on('click', '.popup .btn_submit', function () {
                close(this);
                return false;
            });

            //사진크게보기 팝업
            if (document.querySelector('.btn_zoom_photo')) {
                setPopup('.btn_zoom_photo', '.zoom_photo');

                $('.btn_zoom_photo').on('click', function () {
                    var idx = $('.place_carousel .owl-dot').filter('.active').index();
                    zoomCarousel.trigger('to.owl.carousel', [idx,1]);
                });
            }

            //갤러리 팝업
            if (document.querySelector('.gallery_list')) {
                setPopup('.gallery_item', '.zoom_photo');
            }

            //리뷰팝업
            if (document.querySelector('.btn_write_review')) {
                setPopup('.btn_write_review', '.review_popup');
            }

            //아이디비밀번호 찾기
            if (document.querySelector('.btn_find_account')) {
                setPopup('.btn_find_account', '.find_account');
            }

            //추천 다이빙
            if (document.querySelector('.main_recomm_list')) {
                setPopup('.main_recomm_list li > a', '.recomm_article');
                $(document).on('click', '.popup .btn_back' , function () {
                    close(this);
                });
            }

            //상세보기 모바일 공유하기 팝업
            if (document.querySelector('.place_hd_feature')) {
                setPopup('.place_hd_feature .feature_02', '.place_hd_share');

                $(window).on('resize', function () {
                    if ($('.place_hd_share').hasClass('show') && isDesktop()) {
                        close(document.body);
                    }
                });
            }
            /* 20180511 추가 */
            //SMS 발송
            if (document.querySelector('.btn_send_msg')) {
                setPopup('.btn_send_msg', '.send_msg.v1');
            }
            //결제링크전송
            if ( document.querySelector('.btn_send_link')) {
                setPopup('.btn_send_link', '.send_msg.v2');
            }
            //지역한눈에보기
            if (document.querySelector('.show_all_loc')) {
                setPopup('.show_all_loc', '.all_loc_map');
            }
            /* //20180511 추가 */
        }()),
        /* jquery 스트롤바 http://rocha.la/jQuery-slimScroll */
        setScrollbar = (function () {
            if (!document.querySelector('.js_scrollbar')) {
                return false;
            }

            var init = function (el) {
                var $el = $(el), height = 0;

                height = $el.parent().outerHeight();

                $el.slimScroll({
                    height: height,
                    size: '4px',
                    color: '#bebebe',
                    distance: '8px',
                    alwaysVisible: true
                });
            };

            $('.js_scrollbar').each(function () {
                init(this);

                if ($(this).hasClass('mob') && isDesktop()) {
                    $(this).attr('style','').slimScroll({
                        destroy: true
                    });
                }
            });

            $(window).on('resize', function () {
                var height = 0;

                $('.js_scrollbar').each(function () {
                    /* 20180320 수정 */
                    var $outer = $(this.parentNode).parent();

                    if ($(this).hasClass('mob') && isDesktop()) {
                        $(this).attr('style','').slimScroll({
                            destroy: true
                        });
                        return false;
                    }

                    if (!$(this).parent().hasClass('slimScrollDiv')) {
                        init(this);
                    } else {
                        height = $outer.outerHeight();

                        if (height === 0 && $outer.css('max-height')) {
                            height = $outer.css('max-height');
                        }

                        $(this).height(height).closest('.slimScrollDiv').height(height);
                    }                    
                    /* //20180320 수정 */
                });
            });
        }()),
        /* 뷰페이지 상단 예약하기 버튼 이동 */
        setMoveToReservation = (function () {
            if (!document.querySelector('.view_page')) {
                return false;
            }

            $('.place_top_feature .btn_reservation').on('click', function (e) {
                e.preventDefault();
                if (isDesktop()) {
                    $('.tab_list').children().eq(1).trigger('click');
                } else {
                    $('.room_wrap').toggleClass('show');
                }
            });
        }()),
        /* 지도검색 place 타입버튼 on,off */
        setBtnPlaceType = (function () {
            if (!document.querySelector('.place_type_list')) {
                return false;
            }

            $('.place_type_list').on('click', 'li', function () {
                $(this).toggleClass('on');
            });
        }()),
        /* 커스텀 input file 선택 파일명 표시 */
        setCustomInputFile = (function () {
            if (!document.querySelector('.file_wrap')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('change', '.file_wrap input', function (e) {
                var files = this.files,
                    filename = '',
                    $selected = $(this.parentNode).find('.selected_txt');

                if (files && files.length) {
                    filename = files[0].name;
                    $selected.text(filename);
                } else if (files && files.length === 0) {
                    $selected.text('선택된 파일 없음');
                }
            });
        }()),
        /* 리뷰작성 별점 이벤트 */
        chgStarRatingValue = (function () {
            if (!document.querySelector('.rating_input')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.rating_input input', function () {
                if (this.checked) {
                    $('.rating_input .selected_val').text(Number(this.value).toFixed(1));
                }
            });

        }()),
        /* 리뷰작성 텍스트 개수 체크 */
        /* 20180511 수정 */
        chkTextCount = (function () {
            function TextCounter (opt) {
                this.$input = opt.input;
                this.$target = opt.target;
                this.max = opt.max;
                this.color = opt.color;
            }

            TextCounter.prototype.count = function () {
                var val = this.$input.val(),
                    cnt = val.length;

                if (cnt > this.max) {
                    cnt = this.max;
                    this.$input.val(val.substring(0, this.max));
                }

                this.$target.css({ color: this.color }).text(cnt);
            };
            TextCounter.prototype.init = function () {
                var _ = this;

                _.$input.on('keydown keyup', function () {
                    _.count();
                });
            };

            if ($('.review_input .i_area').length) {
                var review_cnt = new TextCounter({
                    input: $('.review_input .i_area'),
                    target: $('.review_input .txt_cnt'),
                    max: 600,
                    color: '#f00'
                });
                review_cnt.init();
            }

            if ($('.send_msg .i_area').length) {
                var sms_cnt = new TextCounter({
                    input: $('.send_msg .i_area'),
                    target: $('.send_msg .txt_cnt'),
                    max: 1000,
                    color: '#1cb2c6'
                });
                sms_cnt.init();
            }
        }()),
        /* 체크박스 전체동의 이벤트 */
        chkAllChkbox = (function () {
            if (!document.querySelector('.btn_check_all')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_check_all', function () {
                var checkAll = this,
                    name = checkAll.getAttribute('name'),
                    $items = $('input[type="checkbox"]').filter(function () {
                        if (this !== checkAll) {
                            return this.getAttribute('name') === name;
                        } else {
                            return false;
                        }
                    });

                if ($items.length) {
                    $items.each(function () {
                        this.checked = checkAll.checked;
                    });
                }
            });

            /* 20180511 수정 */
            $(document).on('click', 'input[type="checkbox"]', function () {
                var name = this.getAttribute('name'),
                    cnt = 0,
                    checkAll = $('.btn_check_all').filter(function () {
                        return this.getAttribute('name') === name;
                    })[0],
                    $items = $('input[type="checkbox"]').filter(function () {
                        if (this !== checkAll) {
                            return this.getAttribute('name') === name;
                        } else {
                            return false;
                        }
                    });

                if (checkAll) {
                    for(var i=0, len=$items.length; i<len; i++) {
                        if ($items[i].checked) {
                            cnt +=1;
                        }
                    }

                    if (cnt === $items.length) {
                        checkAll.checked = true;
                    } else {
                        checkAll.checked = false;
                    }
                }
            });
        }()),
        /* 메인 추천다이빙 스크롤 이벤트 */
        scrollMainRecommList = (function () {
            if (!document.querySelector('.main_recomm_list')) {
                return false;
            }

            $(window).on('load', function () {
                var $list = $('.main_recomm_list'),
                    $inner = $list.children('ol');

                $inner.width(($inner.children().eq(0).outerWidth()
                        + parseInt($inner.children().eq(0).css('margin-right')))
                        * $inner.children().length
                    );

                if ($list.width() < $inner.width()) {
                    var max = $list.width() - $inner.width(),
                        min = 0;

                    $list.on('wheel', function (e) {
                        if (isDesktop()) {
                            var $this = $(this),
                                evt = e.originalEvent,
                                offset = $this.offset().left - $inner.offset().left,
                                direction = evt.deltaY < 0 ? 1 : -1,
                                ypos = 0;

                            ypos = (offset - (70 * direction)) * -1;

                            if (ypos > min) {
                                ypos = min;
                            } else if (ypos < max) {
                                ypos = max;
                            }

                            $inner.css({
                                'transform': 'translate('+ ypos +'px,0px)'
                            });

                            if (ypos === min || ypos === max) {
                                return true;
                            }

                            return false;
                        }
                    });

                    $(window).on('resize',function () {
                        $inner.width(($inner.children().eq(0).outerWidth()
                                + parseInt($inner.children().eq(0).css('margin-right')))
                                * $inner.children().length
                            );

                        if (!isDesktop()) {
                            $inner.css({'transform':'translate(0px,0px)'});
                        } else {
                            max = $list.width() - $inner.width();
                        }
                    });
                }
            });
        }()),
        /* 메인 추천다이빙 공유하기 표시 */
        expandShareList = (function () {
            if (!document.querySelector('.article_share')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_share', function () {
                $(this).parent().toggleClass('expanded');
            });
        }()),
        /* 반응형 이미지 변경 */
        setResponsiveImg = (function() {
            if (!document.querySelector('.res_img')) {
                return false;
            }

            var init = function() {
                $('.res_img').each(function () {
                    var origin = $(this).attr('data-src').split(',');
                    var src = isDesktop() ? origin[1] || '' : origin[0] || '';
                    $(this).attr('src', src);
                });
            };

            $(window).on('resize', init);
            init();
        }()),
        /* 모바일 탭리스트 보기 버튼 이벤트 */
        setBtnShowTabList = (function () {
            if (!document.querySelector('.mobile_tab')) {
                return false;
            }

            $('.tab_list').on('click', 'li', function(e) {
                var $this = $(this),
                    $parent = $(this.parentNode),
                    text = e.target.textContent;

                if ($parent.prev().hasClass('btn_show_list')) {
                    $this.siblings().removeClass('on');
                    $this.addClass('on');
                    $parent.parent().removeClass('show');
                    $parent.prev().find('.selected_txt').text(text);
                }
            });

            $('.mobile_tab .selected_txt').text($('.mobile_tab').next().find('.on').text());
        }()),
        /* 모바일 검색바 show menu 버튼 이벤트 */
        setBtnShowMenu = (function () {
            if (!document.querySelector('.btn_show_menu')) {
                return false;
            }
            /* 20180511 수정 */
            $(document).on('click', '.btn_show_menu', function () {
                var $this = $(this),
                    $parent = $(this.parentNode),
                    $target = $('.' + $this.attr('data-menu'));

                $parent.siblings().removeClass('on');
                $parent.addClass('on');

                if ($target.length) {
                    $target.siblings().removeClass('show');
                    $target.addClass('show');
                }
            });
        }()),
        /* 모바일 header 필터버튼 이벤트 */
        setBtnshowFilter = (function () {
            if (!document.querySelector('.btn_show_filter')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_show_filter', function () {
                if ($('.search_bar').length) {
                    //일반 검색
                    $('.search_bar .show').removeClass('show');
                    $('.search_bar .btn_show_menu').eq(0).trigger('click');
                    $('.search_bar').toggleClass('show');
                } else if ($('.search_attr_wrap').length) {
                    //지도 검색
                    $('.search_attr_wrap').toggleClass('show');
                }
            });
        }()),
        /* 모바일 고객센터 검색란 width 조정 */
        expandSearchInputWidth = (function () {
            if (!document.querySelector('.board_search')) {
                return false;
            }

            $('.board_search .i_keyword').on('focusin', function () {
                var $parent = $(this.parentNode);

                if ($parent.width() < 200) {
                    $parent.css('width', '100%');
                }
            })
            .on('focusout', function () {
                $(this).parent().css('width', '');
            });
        }()),
        /* 모바일 숙소목록 펼치기 */
        expandSearchedResult = (function () {
            if (!document.querySelector('.searched_result_wrap')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '.btn_show_result', function () {
                $('.all_result_wrap').toggleClass('expanded');
            });
        }()),
        /* 모바일 gnb 메뉴 보기 */
        expandGnbMenu = (function () {
            var $gnb = $('.gnb');

            $('.btn_expand_menu').on('click', function () {
                $gnb.addClass('expanded');
            });

            $('.side_nav').on('click', function (e) {
                if ($gnb.hasClass('expanded') && !$(e.target).hasClass('btn_expand_menu')
                    && !$(e.target).closest('.side_nav_wrap').length) {
                    $gnb.removeClass('expanded');
                }
            });
        }()),
        /* 모바일 gnb 서브메뉴 열기 */
        expandGnbSubMenu = (function () {
            $('.btn_show_submenu').on('click', function (e) {
                e.preventDefault();
                $(this).siblings('.gnb_sub_menu').stop().slideToggle(200);
                $(this).parent().toggleClass('collapse');
            });
        }()),
        /* 마이페이지 회원레벨 툴팁 열기 */
        showTooltip = (function () {
            if (!document.querySelector('[data-target="tooltip"]')) {
                return false;
            }

            /* 20180511 수정 */
            $(document).on('click', '[data-target="tooltip"]', function () {
                $(this).toggleClass('on');
                return false;
            });
        }()),
        /* 숙소예약 세부내역열기 */
        /* 20180511 수정 */
        expandRsvDetail =(function () {
            $(document).on('click', '.btn_exp_detail', function () {
                $(this).closest('li').toggleClass('expanded').find('.detail_wrap').stop().slideToggle(300);
            });
            
            /* 20180511 수정 */
            $(document).on('click', '.rsv_c_num',function (e) {
                e.preventDefault();
                $(this).closest('li').find('.btn_exp_detail').trigger('click');
            });
        }()),
        /* 회사소개 스크롤애니메이션 */
        /* 20180327 추가 */
        setScrollingAni = (function () {
            if (!document.querySelector('.tweens')) {
                return false;
            }

            var offset = 700;

            $(window).on('scroll', function (e) {

                var $tweens = $('.tweens'),
                    ypos = 0, maxpos = 0, curpos = $(window).scrollTop();

                for(var i=0, len = $tweens.length; i < len; i++) {
                    ypos = $tweens.eq(i).offset().top - offset;
                    maxpos = ypos + offset + $tweens.eq(i).outerHeight();

                    if (curpos >= ypos && curpos < maxpos) {
                        $tweens.eq(i).addClass('tweening');
                    }
                }
            });
            $('html, body').animate({scrollTop: $(window).scrollTop() + 2}, 100);
        }()),
        /* 20180410 추가 */
        /* 강사회원 가입 폼 표시 */
        showExtraFrmInput = (function () {
            if (!document.querySelector('.show_i_extra')) {
                return false;
            }

            var name = $('.show_i_extra').attr('name'),
                $inputs = $('input[name=' + name + ']');

            $inputs.on('change', function () {
                if (this.checked && this.getAttribute('class') && this.getAttribute('class').indexOf('show_i_extra') > -1) {
                    $('.extra_input').show();
                } else {
                    $('.extra_input').find('.i_txt').val('');
                    $('.extra_input').hide();
                }
            });
        }()),

        /* 메인 지역명 클릭 이벤트 */
        /* 20180511 추가 */
        setlocationItem = (function () {
            if (!$('.location_list').length) {
                return false;
            }

            var $list = $('.location_list'),
                $btnShowList = $list.closest('.ddbox_wrap').find('.btn_show_list'),
                $selected = $btnShowList.find('.selected_txt'),
                $active = null;
            
            $list.on('click', '.item', function () {
                var $this = $(this),
                    text = '';

                if ($active) {
                    $active.parent().removeClass('active').closest('.country').prev('.area').removeClass('active');
                }

                /* 부모 li태그와 .area 요소에 active 클래스 붙임 */
                $this.parent().addClass('active').closest('.country').prev('.area').addClass('active');
                $active = $this;

                if ($this.closest('.city').length) {
                    text = $this.closest('.city').prev('.item').text() + ', ' + $this.text();
                } else {
                    text = $this.text();
                }

                $selected.val(text);
                $btnShowList.trigger('click');
                $selected.focus();
            });

            $selected.on('click', function (e) {                
                /* 20180621 수정 */
                if (!$list.closest('.ddbox_wrap').hasClass('show')) {
                    $btnShowList.trigger('click');
                }
            });
            
            /* 20180614 추가 */
            $(document).on('keyup', '.main_srch_frm #country', function () {
                var $input = $(this),
                    $list = $('.location_list');

                if (!$list.find('li').filter('.active').length) {
                    return false;
                }

                if (($input.val().split(',')[1] && 
                    $input.val().split(',')[1].indexOf($list.find('.active').children('.item').text()) < 0) ||
                    $input.val().indexOf($list.find('.active').children('.item').text()) < 0) {
                    $('.location_list .active').removeClass('active');
                }
            });
            /* //20180614 추가 */
        }()),
        /* 발송회원관리 회원추가 입력폼 추가 이벤트 */
        /* 20180511 추가 */
        addFrmMember = (function () {
            if (!$('.btn_add_member').length || !$('.member_list').length) {
                return false;
            }

            var cnt = 0, html = '',
                $list = $('.member_list > ol'),
                getHtml = function () {
                    var temp = '<li><div class="cols"><div class="col"><span class="no">' + cnt + '</span></div>' +
                        '<div class="col"><input type="text" name="name' + cnt + '" id="name' + cnt + '" placeholder="이름" class="i_txt" /></div>' +
                        '<div class="col"><input type="tel" name="phone' + cnt + '" id="phone' + cnt + '" placeholder="연락처" class="i_txt" /></div>' +
                        '<div class="col"><input type="email" name="email' + cnt + '" id="email' + cnt + '" placeholder="이메일" class="i_txt" /></div>' +
                        '<div class="col"><input type="tel" name="price' + cnt + '" id="price' + cnt + '" placeholder="결제금액" class="i_txt" /></div>' +
                        '<div class="col"><button type="button" class="btn_send_msg">SMS발송</button><button type="button" class="btn_send_link">결제링크전송</button>' +
                        '<button type="button" class="btn_exp_detail">필수추가정보입력</button></div></div>' +
                        '<div class="detail_wrap"><div class="detail_content"><div class="frm_table profile">' +
                        '<table><colgroup><col style="width:17.5%;"><col style="width:82.5%;"></colgroup><tbody>' +
                        '<tr><th>영문 성명<span class="req_char">*</span></th>' +
                        '<td><input type="text" name="ename' + cnt + '" id="ename' + cnt + '" placeholder="이름/여권의 영문명과 동일하게 입력" class="i_txt"></td></tr>' +
                        '<tr><th>성별</th>' +
                        '<td><span class="checkbox_wrap"><input type="radio" name="gender' + cnt + '" id="male' + cnt + '" value="1" checked>' +
                        '<label for="male' + cnt + '"><span>남</span></label></span><span class="checkbox_wrap"><input type="radio" name="gender' + cnt + '" id="female' + cnt + '" value="2" class="show_i_extra">' +
                        '<label for="female' + cnt + '"><span>여</span></label></span></td></tr>' +
                        '<tr><th>여권번호<span class="req_char">*</span></th>' +
                        '<td><div class="inline_inputs"><span class="select_wrap input_st_03"><label for="pCountry' + cnt + '">' +
                        '<span class="selected_txt">발행국</span></label><select name="pCountry' + cnt + '" id="pCountry' + cnt + '">' +

                        '<option value="" selected disabled>발행국</option><option value="1">대한민국</option><option value="2">미국</option><option value="3">중국</option>' +

                        '</select></span><span class="input_st_03"><input type="text" name="pNum' + cnt + '" id="pNum' + cnt + '" class="i_txt"></span></div></td></tr>' +
                        '<tr><th>여권<span class="mobile_blocked"></span> 만료일<span class="req_char">*</span></th>' +
                        '<td><div class="inline_inputs"><span class="input_st_01"><input type="tel" name="pYear' + cnt + '" id="pYear' + cnt + '" maxlength="4" class="i_txt"> 년</span>' +
                        '<span class="input_st_01"><input type="tel" name="pMonth' + cnt + '" id="pMonth' + cnt + '" maxlength="2" class="i_txt"> 월</span>' +
                        '<span class="input_st_01"><input type="tel" name="pDay' + cnt + '" id="pDay' + cnt + '" maxlength="2" class="i_txt"> 일</span></div></td></tr>' +
                        '<tr><th>생년월일</th>' +
                        '<td><div class="inline_inputs"><span class="input_st_01"><input type="tel" name="birthYear' + cnt + '" id="birthYear' + cnt + '" maxlength="4" class="i_txt"> 년</span>' +
                        '<span class="input_st_01"><input type="tel" name="birthMonth' + cnt + '" id="birthMonth' + cnt + '" maxlength="2" class="i_txt"> 월</span>' +
                        '<span class="input_st_01"><input type="tel" name="birthDay' + cnt + '" id="birthDay' + cnt + '" maxlength="2" class="i_txt"> 일</span></div></td></tr>' +
                        '<tr><th>소속단체<span class="req_char">*</span></th>' +
                        '<td><div class="inline_inputs"><span class="select_wrap assoc_vendor"><label for="assoc' + cnt + '"><span class="selected_txt">PADI</span></label>' +
                        '<select name="assoc' + cnt + '" id="assoc' + cnt + '">' +

                        '<option value="PADI">PADI</option><option value="SDI">SDI</option><option value="IANTD">IANTD</option>' +
                        '<option value="CMAS">CMAS</option><option value="NAUI">NAUI</option><option value="SSI">SSI</option><option value="NASE">NASE</option>' +
                        '<option value="BASAC">BASAC</option><option value="">직접입력</option>' +

                        '</select></span><span class="input_st_07 hidden"><input type="text" name="assoc' + cnt + '" id="assoc' + cnt + '" class="i_txt i_assoc_vendor"></span></div></td></tr>' +
                        '<tr><th>C-CARD<span class="req_char">*</span></th>' +
                        '<td><div class="select_wrap"><label for="ccard' + cnt + '"><span class="selected_txt">OPEN WATER</span></label>' +
                        '<select name="ccard' + cnt + '" id="ccard' + cnt + '">' +

                        '<option value="OPEN WATER">OPEN WATER</option><option value="ADVANCED-OPENWATER">ADVANCED-OPENWATER</option>' +
                        '<option value="RESCUE">RESCUE</option><option value="MASTER">MASTER</option><option value="INSTRUCTOR">INSTRUCTOR</option>' +

                        '</select></div></td></tr><tr><th>로그수<span class="req_char">*</span></th>' +
                        '<td><input type="tel" name="log' + cnt + '" id="log' + cnt + '" class="i_txt"></td></tr>' +
                        '<tr><th>마지막<span class="mobile_blocked"></span> 다이빙<span class="req_char">*</span></th>' +
                        '<td><div class="select_wrap"><label for="lastlog' + cnt + '"><span class="selected_txt">선택</span></label>' +
                        '<select name="lastlog' + cnt + '" id="lastlog' + cnt + '">' +

                        '<option value="" selected disabled>선택</option></select>' +

                        '</div></td></tr></tbody></table></div></div></div></li>';
                    return temp;
                };

            $('.btn_add_member').on('click', function () {
                cnt = $list.children().length + 1;
                html = getHtml;
                $list.append(html);
            });
        }());

        /* 20180612 추가 */
        /* 메인 지역명 자동완성 표시, 숨김 */
        (function setAutocomplete () {
            $(document).on('keydown', '.main_srch_frm #country', function () {
                $('.main_srch_frm .keywords').addClass('show');
            })
            .on('focusout', '.main_srch_frm #country', function () {
                $('.main_srch_frm .keywords').removeClass('show');
            });
        }());

        /* 20180612 추가 */
        /* 메인 리브어보드 준비중 팝업 */
        (function showPrepareNotice () {
            $(document).on('change', '.main_srch_frm input[type="radio"]', function () {
                if (this.value === '리브어보드') {
                    $('.main_srch_frm .col_3').append('<div class="notice_cover" tabindex="-1"><span class= "cover"></span>' + 
                    '<p>리브어보드 실시간 예약은 준비중 입니다.<br> 상단메뉴로 이동 후 검색해 주시기 바랍니다.</p></div>');
                } else {
                    $('.main_srch_frm .notice_cover').remove();
                }
            });
        }());

        /* 20180615 추가 */        
        /* 탭메뉴 클릭시 패널 표시, 숨김 */
        (function shoTabPanel() {
            $(document).on('click', '.tab_menu[data-toggle] .tab_list > li' , function (e) {
                e.preventDefault();

                $(this).addClass('on').siblings().filter('.on').removeClass('on');
                $(this).parent().siblings('.tab_panel').filter('.show').removeClass('show');
                $(this).parent().siblings('.tab_panel').eq($(this).index()).addClass('show');
            });

            if ($('.tab_menu[data-toggle]').length) {
                $('.tab_menu[data-toggle] .tab_list').children().eq(0).trigger('click');
            }
        }());

        /* 20180615 추가 */
        //Single datepicker input setting
        (function setDatepicker () {
            if (!$('.date_input.v2').length) {
                return false;
            }
            $('.date_input.v2 .i_txt').datepicker({
                dateFormat: 'yy-mm-dd',
                minDate: 0,
                defaultDate: 0,
                prevText: '이전 달',
                nextText: '다음 달',
                monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
                dayNames: ['일', '월', '화', '수', '목', '금', '토'],
                dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
                dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
                showMonthAfterYear: true,
                yearSuffix: '년',
                beforeShow: function (input) {
                    if (!isDesktop()) {
                        setTimeout(function () {
                            $('#ui-datepicker-div').css({ 'top': $(input).offset().top + $(input).outerHeight() + 8, 'bottom': 'auto', 'left': '0', 'right': '0' });
                        });
                    }
                } 
            });
        }());
});